var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item flex"},[_c('div',{staticClass:"content-item-label"},[_vm._v("摘要")]),_c('el-input',{staticClass:"item-input",attrs:{"type":"textarea","show-word-limit":"","rows":6,"resize":"none","maxlength":"120","placeholder":"请输入内容"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }